import KitService from './../_services/KitService'
import { kitModel } from './../_model/kit'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'

const state = {
  stateButton: false,
  loading: false,
  loadingStore: false,
  dropdown: [],
  kits: [],
  kitSelecionado: undefined,
  erros: '',

}

const getters = {
  GET_KITS : (state) => state.kits,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  SET_STATE_BUTTON: (state, value) => {
    state.stateButton = value
  },

  KIT_SELECTED : (state, { kit }) => {
    state.kitSelecionado = Object.assign({}, kit)
  },

  SET_KITS : (state, { kits }) => {
    state.kits = kits
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.kitSelecionado = undefined,

}

const actions = {

  GET_KITS : async ({ commit }) => {
      commit('SET_KITS', { kits : []})
      commit('ERASE_ERROS')
      await KitService.getKits()
      .then(response => {
        if (response.data.status) {
          commit('SET_KITS', { kits : response.data.kitcaptacaos })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      })
  },

  GET_KIT : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await KitService.getKit(id)
    .then(response => {
      if (response.data.status) {
        commit('KIT_SELECTED', { kit : response.data.kitcaptacao })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })

  },

  STORE_KIT : async ({ commit, dispatch }, kit) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!kit.id || !(kit.id > 0)) { 
        var response = await KitService.postKit(kit)
      } else {
        var response = await KitService.putKit(kit.id, kit)
      }

      if (response.data.status) {
        commit('KIT_SELECTED', { kit : response.data.kitcaptacao })
          await dispatch('GET_KITS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      } 

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_KIT : async ({ commit, dispatch }, kit) => {
    commit('ERASE_ERROS')
    try {
      var response = await KitService.deleteKit(kit.id)

      if (response.data.status) {
        await dispatch('GET_KITS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      console.log('Deu erro na api')
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    }
  },

  KIT_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_KIT', id)
    } else {
      var obj = new kitModel.kit()
      await commit('KIT_SELECTED', { kit: obj })
    }    
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Kits/_store/index.js